
import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./Folder.module.scss";
import { v4 } from "uuid";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import * as YStyled from "../../../Styleds";
const Folder = ({ folder ,disabled=false, onAdd, onClick }) => {
    const [save, set_save] = useState(false);
    useEffect(() => {
    }, [])
    return <div className={`${style.folder} ${disabled?style.disabled:""}`} onClick={e => {
        if (onClick&&disabled===false)
            onClick(folder);
    }}>
        <div className={style.iconBg}>
            <img src="./assets/ui/save2.png" />
        </div>
        <div className={style.info}>
            <YStyled.Span size={17} fontWeight={600}>{folder.pocket_lists_name}</YStyled.Span>
            <YStyled.Span size={15} fontWeight={400}>{folder.items?.length}個地點</YStyled.Span>
        </div>
        {onAdd &&
            <div className={style.addBtn}>
                <IconButton onClick={e => {
                    if (save === false) {
                        onAdd();
                        set_save(true)
                    }
                }}>
                    {save ?
                        <div className={style.existIcon}>
                            <DoneIcon />
                        </div>
                        :
                        <div className={style.addIcon}>
                            <AddIcon />
                        </div>
                    }
                </IconButton>
            </div>
        }
    </div>
}

export default Folder;